import React from 'react';
import styled from 'styled-components';
import { assetConfig } from '../config/assets';

const HeaderContainer = styled.header.attrs({
  className: 'header-container'
})`
  padding: 20px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 768px) {
    padding: 15px 20px;
  }
`;

const LogoContainer = styled.div.attrs({
  className: 'logo-container'
})`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 6px;
  max-width: 1200px;
  
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const TeamLogo = styled.img.attrs({
  className: 'team-logo'
})`
  /* Styles are now handled by global .team-shield class */
`;

const TeamLogoFallback = styled.div.attrs({
  className: 'team-logo-fallback'
})`
  width: 48px;
  height: 48px;
  background: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 10px;
  color: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 8px;
  }
`;

const Header: React.FC = () => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.style.display = 'none';
    const fallback = e.currentTarget.nextElementSibling as HTMLElement;
    if (fallback) {
      fallback.style.display = 'flex';
    }
  };

  return (
    <HeaderContainer>
      <LogoContainer>
        {assetConfig.teamLogos.map((team, index) => (
          <div key={index} style={{ position: 'relative' }}>
            <TeamLogo 
              src={team.logoUrl} 
              alt={team.alt}
              onError={handleImageError}
              className="team-shield"
            />
            <TeamLogoFallback style={{ display: 'none', position: 'absolute', top: 0, left: 0 }}>
              {team.name.slice(0, 3).toUpperCase()}
            </TeamLogoFallback>
          </div>
        ))}
      </LogoContainer>
    </HeaderContainer>
  );
};

export default Header;